<p-panel header="Services" [toggleable]="true">
  <div class="order-line-sticky-header p-2 gap-2">
    <div class="align-items-center d-flex col-lg-12 mb-3">
      <div class="nav-link p-0 d-flex align-items-center">
        <i class="icon-Add me-1"></i>
        <a class="link" (click)="addNewService()">Add Line</a>
      </div>

      <div class="ms-3 nav-link p-0 d-flex align-items-center delete">
        <div>
          <i class="icon-Delete me-2"></i>
          <a class="link" (click)="onDeleteLines()">Remove</a>
        </div>
      </div>
      <div class="ms-3 nav-link p-0 d-flex align-items-center delete">
        <div>
          <i class="icon-Copy me-2"></i>
          <a class="link" (click)="onCopyLines()">Copy Lines</a>
        </div>
      </div>
      <!-- <div
        class="ms-3 nav-link p-0 d-flex align-items-center"
        *ngIf="selectedServiceLines && selectedServiceLines.length"
      >
        <a class="link" (click)="addressAssignment()">Address Assignment</a>
      </div> -->
    </div>
    <div class="indropdowntable col-lg-12 fixTableHead table-hgt">
      <p-table
        #dt
        [value]="filteredServiceLines"
        [(selection)]="selectedServiceLines"
        [rowHover]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [paginator]="false"
        [filterDelay]="0"
        dataKey="portalKeyD365"
        editMode="row"
        selectionMode="multiple"
        [scrollable]="true"
        scrollHeight="310px"
        styleClass="table-listing">
        <ng-template pTemplate="header">
          <tr class="table-head">
            <th class="colwdth-small"></th>
            <th class="colwdth-small d-flex justify-content-center">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th class="name">SKU</th>
            <!-- <th class="purpose">External Item Id</th> -->
            <th class="purpose colwdth-large">Description</th>
            <!-- <th class="email">Ship date</th> -->
            <!-- <th class="save">In-hands date</th> -->
            <!-- <th class="save">Shipping Method</th> -->
            <!-- <th class="save">Account</th> -->
            <!-- <th class="exist colwdth-large">Factory Notes</th> -->
            <!-- <th class="confirmation">Product name</th> -->
            <th class="Invoice">Vendor</th>
            <th class="Invoice">Vendor name</th>
            <!-- <th class="Invoice">Quantity</th> -->
            <!-- <th class="Invoice">Unit</th> -->
            <th class="Invoice">Quantity</th>
            <th class="Invoice">Unit price</th>
            <!-- <th class="Invoice">Currency</th> -->
            <th class="Invoice">Amount</th>
            <!-- <th class="Invoice">Price in transaction currency</th>
              <th class="Invoice">Amount in transaction currency</th> -->
            <!-- <th class="Invoice">Delivery selection</th> -->
            <!-- <th class="Invoice cell-left">Address name/description</th> -->
            <th class="Invoice cell-left">Ship-to address</th>
            <!-- <th class="Invoice">Final PO</th> -->
            <!-- <th class="Invoice">Excluded</th> -->
          </tr>
        </ng-template>
        <ng-template
          pTemplate="body"
          let-serviceLine
          let-editing="editing"
          let-ri="rowIndex">
          <ng-container>
            <tr
              class="p-selectable-row"
              [pSelectableRow]="serviceLine"
              [pEditableRow]="serviceLine">
              <td class="colwdth-small">
                <p-button
                  *ngIf="!editing"
                  pButton
                  pRipple
                  type="button"
                  (click)="redirectToServiceEdit(serviceLine, ri)"
                  icon="pi pi-pencil"
                  variant="text"
                  severity="secondary"
                  class="p-button-text m-0 p-0" />
                <p-button
                  *ngIf="editing"
                  pButton
                  pRipple
                  type="button"
                  pSaveEditableRow
                  icon="pi pi-check"
                  class="p-button-success m-0 p-0"
                  variant="text"
                  severity="secondary"
                  (click)="onRowEditSave(serviceLine)" />
                <p-button
                  *ngIf="editing"
                  pButton
                  pRipple
                  type="button"
                  pCancelEditableRow
                  icon="pi pi-times"
                  variant="text"
                  severity="secondary"
                  class="p-button-danger m-0 p-0" />
              </td>
              <td class="colwdth-small">
                <p-tableCheckbox
                  [value]="serviceLine"
                  [pEditableRow]="serviceLine"
                  [pSelectableRow]="serviceLine"></p-tableCheckbox>
              </td>
              <td
                class="d-holder drop-holder"
                style="position: relative"
                pEditableColumn
                pEditableColumnField="itemNumberD365">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-select
                      [editable]="editing ? false : true"
                      class="invoiceemaildropdown"
                      (onChange)="itemSelected($event, serviceLine)"
                      [(ngModel)]="serviceLine.itemNumberD365"
                      appendTo="body"
                      [options]="items"
                      optionLabel="itemNumberD365"
                      optionValue="itemNumberD365"
                      [filter]="true"
                      [showClear]="true">
                    </p-select>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ serviceLine.itemNumberD365 }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <!-- <td class="externalItemId">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      [(ngModel)]="serviceLine.externalItemNumberD365"
                      required
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ serviceLine.externalItemNumberD365 }}
                  </ng-template>
                </p-cellEditor>
              </td> -->
              <td
                class="description colwdth-large cell-left hoverwdth"
                [ngClass]="{
                  'trimmeddescription trimmedby50char':
                    descriptionCharacterCond,
                }"
                pEditableColumn
                pEditableColumnField="lineDescriptionD365"
                [pTooltip]="serviceLine.lineDescriptionD365"
                [tooltipOptions]="toolTipOptions">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <textarea
                      style="height: auto; max-height: 150px; width: 100%"
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      [(ngModel)]="serviceLine.lineDescriptionD365"
                      (keydown)="
                        onTextFieldKeyDown(
                          $event,
                          serviceLine,
                          'lineDescriptionD365'
                        )
                      "></textarea>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{
                      descriptionCharacterCount(serviceLine.lineDescriptionD365)
                    }}
                    {{ serviceLine.lineDescriptionD365 }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <!-- <td class="number">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      jniAutoCompleteBlocker
                      name="shipDate"
                      id="shipDate"
                      class="date-input"
                      type="date"
                      [value]="
                        serviceLine.requestedShippingDateD365
                          | date: 'yyyy-MM-dd'
                      "
                      [min]="shipDateCurrentdate"
                      (focusout)="shipDateChange($event, serviceLine)"
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    <span
                      *ngIf="
                        serviceLine?.requestedShippingDateD365
                          | hidedynamicsdate
                      "
                    >
                      {{
                        serviceLine?.requestedShippingDateD365
                          | date: 'MM-dd-yyyy'
                      }}
                    </span>
                  </ng-template>
                </p-cellEditor>
              </td>
              <td class="number">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      jniAutoCompleteBlocker
                      name="deliveryDate"
                      id="deliveryDate"
                      class="date-input"
                      type="date"
                      [value]="
                        serviceLine.requestedDeliveryDateD365
                          | date: 'yyyy-MM-dd'
                      "
                      [min]="serviceLine.requestedShippingDateD365"
                      (focusout)="deliveryDateChange($event, serviceLine)"
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    <span
                      *ngIf="
                        serviceLine?.requestedDeliveryDateD365
                          | hidedynamicsdate
                      "
                    >
                      {{
                        serviceLine?.requestedDeliveryDateD365
                          | date: 'MM-dd-yyyy'
                      }}
                    </span>
                  </ng-template>
                </p-cellEditor>
              </td>
              <td class="d-holder drop-holder" style="position: relative">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <ng-select
                      [dropdownPosition]="'bottom'"
                      class="p-0 invoiceemaildropdown"
                      (clear)="clearShippingMethod(serviceLine)"
                      (change)="onShippingMethodSelect($event, serviceLine)"
                      [(ngModel)]="serviceLine.deliveryModeIdD365"
                      appendTo=".service-component"
                    >
                      <ng-option
                        *ngFor="let com of shippingProductsList"
                        [value]="com.modeCodeD365"
                      >
                        {{ com.modeDescriptionD365 }}
                      </ng-option>
                    </ng-select>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ serviceLine.deliveryModeIdD365 }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td class="cell-left">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      [(ngModel)]="serviceLine.freightAccountNumD365"
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ serviceLine.freightAccountNumD365 }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td
                class="description colwdth-large cell-left"
                [ngClass]="{
                  'trimmeddescription trimmedby50char': descriptionCharacterCond
                }"
              >
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <textarea
                      style="height: auto; max-height: 150px; width: 100%"
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      [(ngModel)]="serviceLine.factoryNotesD365"
                      required
                    ></textarea>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{
                      descriptionCharacterCount(serviceLine.factoryNotesD365)
                    }}
                    {{ serviceLine.factoryNotesD365 }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td class="cell-left">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      [(ngModel)]="serviceLine.productName"
                      disabled
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ serviceLine.productName }}
                  </ng-template>
                </p-cellEditor>
              </td> -->

              <td
                class="quantity cell-left"
                pEditableColumn
                pEditableColumnField="vendorIdD365">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <div>
                      <input
                        #mydrop
                        jniAutoCompleteBlocker
                        type="text"
                        id="vendoraccount"
                        name="vendoraccount"
                        class="form-control vendor-wdth"
                        [value]="vendorAccountNumber"
                        [(ngModel)]="serviceLine.vendorIdD365"
                        (input)="searchVendor$.next($any($event.target).value)"
                        (keyup)="
                          onVendorSearchOpenToggle(
                            vendorDropPopover,
                            $event,
                            mydrop
                          )
                        "
                        (focus)="selectText($event)" />
                      <p-popover
                        class="order-dropdown"
                        #vendorDropPopover
                        aria-labelledby="dropdownBasic1">
                        <div class="indropdowntable" style="height: 310px">
                          <p-table
                            #dt
                            [value]="vendorList"
                            styleClass="p-datatable-customers order-listing"
                            [rowHover]="true"
                            [rows]="10"
                            [showCurrentPageReport]="true"
                            [rowsPerPageOptions]="[10, 25, 50]"
                            [paginator]="false"
                            [filterDelay]="0">
                            <ng-template pTemplate="header">
                              <tr>
                                <th class="name">Name</th>
                                <th class="vaccount">3PL</th>
                                <th class="currency">Currency</th>
                                <th class="sname">Search name</th>
                                <th class="phone">Phone</th>
                                <th class="city">City</th>
                                <th class="state">State</th>
                                <th class="country">Country</th>
                              </tr>
                            </ng-template>
                            <ng-template
                              pTemplate="body"
                              let-vendorList
                              let-rowIndex="rowIndex">
                              <tr
                                class="p-selectable-row mousepointer"
                                (click)="
                                  onVendorRowSelection(
                                    vendorList,
                                    vendorDropPopover,
                                    serviceLine
                                  )
                                ">
                                <td class="name mousepointer">
                                  {{ vendorList.vendorName }}
                                </td>
                                <td class="vaccount mousepointer">
                                  {{ vendorList.vendorAccountNumber }}
                                </td>
                                <td class="sname mousepointer">
                                  {{ vendorList.currency }}
                                </td>
                                <td class="sname mousepointer">
                                  {{ vendorList.vendorSearchName }}
                                </td>
                                <td class="phone mousepointer">
                                  {{ vendorList.phoneNumber }}
                                </td>
                                <td class="city mousepointer">
                                  {{ vendorList.city }}
                                </td>
                                <td class="state mousepointer">
                                  {{ vendorList.state }}
                                </td>
                                <td class="country mousepointer">
                                  {{ vendorList.country }}
                                </td>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                              <tr>
                                <td colspan="20">No vendor found.</td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </div>
                      </p-popover>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ serviceLine.vendorIdD365 }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td class="quantity cell-left">
                {{ serviceLine.vendorNameD365 }}
              </td>

              <td
                class="quantity cell-right"
                pEditableColumn
                pEditableColumnField="orderedPurchaseQuantityD365">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      jniNumberOnly
                      type="text"
                      [(ngModel)]="serviceLine.orderedPurchaseQuantityD365"
                      (keydown)="onQuantityKeyDown($event, serviceLine)"
                      (ngModelChange)="
                        calculateQuantity(
                          serviceLine.orderedPurchaseQuantityD365,
                          serviceLine
                        )
                      "
                      (focus)="selectText($event)" />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ serviceLine.orderedPurchaseQuantityD365 }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <!-- <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <ng-select
                      [dropdownPosition]="'bottom'"
                      class="p-0 invoiceemaildropdown"
                      [ngModelOptions]="{ standalone: true }"
                      [(ngModel)]="serviceLine.purchaseUnitSymbolD365"
                      appendTo=".service-component"
                    >
                      <ng-option *ngFor="let com of unit" [value]="com">
                        {{ com }}
                      </ng-option>
                    </ng-select>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ serviceLine.purchaseUnitSymbolD365 }}
                  </ng-template>
                </p-cellEditor>
              </td> -->
              <td
                class="quantity cell-right"
                pEditableColumn
                pEditableColumnField="purchasePriceD365">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      [(ngModel)]="serviceLine.purchasePriceD365"
                      (keydown)="onUnitPriceKeyDown($event, serviceLine)"
                      (focus)="selectText($event)"
                      (ngModelChange)="
                        onNetConversion(
                          serviceLine.purchasePriceD365,
                          serviceLine
                        )
                      " />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{
                      serviceLine.purchasePriceD365
                        | currency
                          : getCurrencyConvertionCode(
                              serviceLine?.currencyCodeD365 || ""
                            )
                          : "symbol"
                          : "0.4-4"
                    }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <!-- <td class="d-holder">
                {{ serviceLine.currencyCodeD365 }}
              </td> -->
              <td class="ntotal cell-right">
                {{
                  serviceLine.lineAmountD365
                    | currency
                      : getCurrencyConvertionCode(
                          serviceLine?.currencyCodeD365 || ""
                        )
                      : "symbol"
                      : "0.2-2"
                }}
              </td>
              <!-- <td class="ntotal cell-right">
                  {{
                    serviceLine.priceInTransactionCurrency
                      | currency: 'USD':'symbol':'0.2-2'
                  }}
                </td>
                <td class="ntotal cell-right">
                  {{
                    serviceLine.amountInTransactionCurrency
                      | currency: 'USD':'symbol':'0.2-2'
                  }}
                </td> -->
              <!-- <td class="quantity">
                {{ serviceLine.deliverySelectionD365 }}
              </td> -->
              <!-- <td class="quantity cell-left">
                {{ serviceLine.addressDescriptionD365 }}
              </td> -->
              <td class="quantity cell-left">
                {{ serviceLine.shipToAddressD365 }}
              </td>
              <!-- <td class="bul-center">
                <p-checkbox
                  id="finalPo"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="serviceLine.finalPoD365"
                  inputId="finalPo"
                  [binary]="true"
                ></p-checkbox>
              </td>
              <td class="bul-center">
                <p-checkbox
                  id="excluded"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="serviceLine.excludedD365"
                  inputId="excluded"
                  [binary]="true"
                ></p-checkbox>
              </td> -->
            </tr>
          </ng-container>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="20" class="colwdth-large nofound">
              No line item found.
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="20" class="colwdth-large nofound">
              No line item found.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-panel>

<jni-address-assignment
  [(display)]="displayAddressAssignment"
  [headerObject]="purchaseOrderHeader"
  [addressObject]="purchaseOrderHeaderAddress"
  (saveEmit)="onAddressAssignment($event)"
  *ngIf="displayAddressAssignment"></jni-address-assignment>
